module.exports = __webpack_public_path__ + "static/media/adv-img1.fa9121dd.jpg";